import { FETCH_CONTRACT } from "../../actions/types";

const INITIAL_STATE = {};

const contractReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CONTRACT:
      return payload.data;
    default:
      return state;
  }
};

export default contractReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/contract_reducer.js